// import React, { useState, useEffect } from 'react'
// import { Link } from 'react-router-dom'
// import { Form, Button } from 'react-bootstrap'
// import { useDispatch, useSelector } from 'react-redux'
// import Message from '../components/Message'
// import Loader from '../components/Loader'
// import FormContainer from '../components/FormContainer'
// import { getUserDetails, updateUser } from '../actions/userActions'
// import { USER_UPDATE_RESET } from '../constants/userConstants'

// const UserEditScreen = ({ match, history }) => {
//   const userId = match.params.id

//   const [firstName, setFirstName] = useState('')
//   const [lastName, setLastName] = useState('')
//   const [username, setUsername] = useState('')
//   const [email, setEmail] = useState('')
//   const [isAdmin, setIsAdmin] = useState(false)

//   const dispatch = useDispatch()

//   const userDetails = useSelector((state) => state.userDetails)
//   const { loading, error, user } = userDetails

//   const userUpdate = useSelector((state) => state.userUpdate)
//   const {
//     loading: loadingUpdate,
//     error: errorUpdate,
//     success: successUpdate,
//   } = userUpdate

//   useEffect(() => {
//     if (successUpdate) {
//       dispatch({ type: USER_UPDATE_RESET })
//       history.push('/admin/userlist')
//     } else {
//       if (!user.firstName || !user.lastName || !user.username || user._id !== userId) {
//         dispatch(getUserDetails(userId))
//       } else {
//         setFirstName(user.firstName)
//         setLastName(user.lastName)
//         setUsername(user.username)
//         setEmail(user.email)
//         setIsAdmin(user.isAdmin)
//       }
//     }
//   }, [dispatch, history, userId, user, successUpdate])

//   const submitHandler = (e) => {
//     e.preventDefault()
//     dispatch(updateUser({ _id: userId, firstName, lastName, username, email, isAdmin }))
//   }

//   return (
//     <>
//       <Link to='/admin/userlist' className='btn btn-light my-3'>
//         Go Back
//       </Link>
//       <FormContainer>
//         <h1>Edit User</h1>
//         {loadingUpdate && <Loader />}
//         {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
//         {loading ? (
//           <Loader />
//         ) : error ? (
//           <Message variant='danger'>{error}</Message>
//         ) : (
//           <Form onSubmit={submitHandler}>
//             <Form.Group controlId='firstName'>
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 type='firstName'
//                 placeholder='Enter first name'
//                 value={firstName}
//                 onChange={(e) => setFirstName(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='lastName'>
//               <Form.Label>Last Name</Form.Label>
//               <Form.Control
//                 type='lastName'
//                 placeholder='Enter last name'
//                 value={lastName}
//                 onChange={(e) => setLastName(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='username'>
//               <Form.Label>Username</Form.Label>
//               <Form.Control
//                 type='username'
//                 placeholder='Enter username'
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='email'>
//               <Form.Label>Email Address</Form.Label>
//               <Form.Control
//                 type='email'
//                 placeholder='Enter email'
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//               ></Form.Control>
//             </Form.Group>

//             <Form.Group controlId='isadmin'>
//               <Form.Check
//                 type='checkbox'
//                 label='Is Admin'
//                 checked={isAdmin}
//                 onChange={(e) => setIsAdmin(e.target.checked)}
//               ></Form.Check>
//             </Form.Group>

//             <Button type='submit' variant='primary'>
//               Update
//             </Button>
//           </Form>
//         )}
//       </FormContainer>
//     </>
//   )
// }

// export default UserEditScreen


import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { getUserDetails, updateUser, resetUserUpdate } from '../slices/userSlice';
import Meta from '../components/Meta';
import StepUpPasswordModal from '../components/StepUpPasswordModal';
import { requestStepUpToken } from '../utils/stepUp';

const UserEditScreen = ({ match, history }) => {
  const userId = match.params.id;

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isActive, setIsActive] = useState(true);

  const dispatch = useDispatch();

  const {
    loading,
    error,
    userDetails: user,
    userUpdateSuccess,
    loadingUpdateUser,
    errorUpdateUser,
    userInfo,
  } = useSelector((state) => state.user);

  // Admin-role grants (isAdmin/role) are step-up-gated.
  const [showStepUp, setShowStepUp] = useState(false);
  const [stepUpLoading, setStepUpLoading] = useState(false);
  const [stepUpError, setStepUpError] = useState('');

  useEffect(() => {
    if (userUpdateSuccess) {
      dispatch(resetUserUpdate());
      history.push('/admin/userlist');
      return;
    }

    if (!user?._id || user._id !== userId) {
      dispatch(getUserDetails(userId));
    } else {
      setFirstName(user.firstName || '');
      setLastName(user.lastName || '');
      setUsername(user.username || '');
      setEmail(user.email || '');
      setIsAdmin(!!user.isAdmin);
      setIsActive(typeof user.isActive === 'boolean' ? user.isActive : true);
    }
  }, [dispatch, history, userId, user, userUpdateSuccess]);

  const submitHandler = (e) => {
    e.preventDefault();
    setStepUpError('');
    setShowStepUp(true);
  };

  const handleStepUpConfirm = async (password) => {
    setStepUpLoading(true);
    setStepUpError('');
    try {
      const stepUpToken = await requestStepUpToken(password, userInfo?.token);
      setShowStepUp(false);
      dispatch(
        updateUser({
          _id: userId,
          firstName,
          lastName,
          username,
          email,
          isAdmin,
          isActive,
          stepUpToken,
        })
      );
    } catch (e) {
      setStepUpError(e.message);
    } finally {
      setStepUpLoading(false);
    }
  };

  return (
    <>
  <Meta title='Admin — Edit User — The Lotustor' robots='noindex,follow' />
      <Link to='/admin/userlist' className='btn btn-light my-3'>
        Go Back
      </Link>
      <FormContainer>
        <h1>Edit User</h1>
        {(loading || loadingUpdateUser) && <Loader />}
        {(error || errorUpdateUser) && (
          <Message variant='danger'>{error || errorUpdateUser}</Message>
        )}
        {!loading && !error && (
          <Form onSubmit={submitHandler}>
            <Form.Group controlId='firstName'>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter first name'
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='lastName'>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter last name'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='username'>
              <Form.Label>Username</Form.Label>
              <Form.Control
                type='text'
                placeholder='Enter username'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='email'>
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type='email'
                placeholder='Enter email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>

            <Form.Group controlId='isadmin'>
              <Form.Check
                type='checkbox'
                label='Is Admin'
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
              ></Form.Check>
            </Form.Group>

            <Form.Group controlId='isactive'>
              <Form.Check
                type='checkbox'
                label='Is Active'
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              ></Form.Check>
            </Form.Group>

            <Button type='submit' variant='primary'>
              Update
            </Button>
          </Form>
        )}
      </FormContainer>

      <StepUpPasswordModal
        show={showStepUp}
        title='Confirm user update'
        description='For your security, please re-enter your password to save these changes.'
        onCancel={() => setShowStepUp(false)}
        onConfirm={handleStepUpConfirm}
        loading={stepUpLoading}
        error={stepUpError}
      />
    </>
  );
};

export default UserEditScreen;